const ImageService = function () {
};

ImageService.prototype = {
  getCropUrl: function (url, queryParams) {
    if (queryParams === undefined) return url;

    let urlObj = new URL(url);

    for (const p in queryParams) {
      urlObj.searchParams.set(p, queryParams[p]);
    }

    return urlObj.href;
  },
  getImageStyleQueryParams(imageStyle) {
    let queryParams = {};

    switch (imageStyle) {
      case 'imagestyle_circle':
        queryParams.width = 800;
        queryParams.height = 800;
        break;
      case 'imagestyle_landscape':
        queryParams.width = 800;
        queryParams.height = 600;
        break;
      case 'imagestyle_portrait':
        queryParams.width = 600;
        queryParams.height = 800;
        break;
      case 'imagestyle_square':
        queryParams.width = 800;
        queryParams.height = 800;
        break;
      case 'imagestyle_wide':
        queryParams.width = 1200;
        queryParams.height = 600;
        break;
      default:
        queryParams.width = 800;
        queryParams.height = 600;
        break;
    }

    return queryParams;
  }
};

export default ImageService;



// WEBPACK FOOTER //
// ./EcomCore/Models/Media/ImageService.js